import { createPortal } from "react-dom";
import styles from "./FullScreenImageModal.module.css";
import { ArrowLeft, ArrowRight, X } from "lucide-react";

const FullScreenImageModal = ({
  isOpen,
  imageUrl,
  imageLabel,
  onClose,
  images = [],
  currentIndex = 0,
  onNext,
  onPrevious,
}) => {
  if (!isOpen || !imageUrl) return null;

  if (typeof document === "undefined") return null;

  const handleBackdropClick = (event) => {
    // Only close when clicking the backdrop, not the image itself
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  const hasMultipleImages = images.length > 1;
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === images.length - 1;

  const modal = (
    <div
      className={styles.overlay}
      role="presentation"
      onClick={handleBackdropClick}
    >
      <div className={styles.modalContent}>
        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close full screen image"
        >
          <X size={20} />
        </button>

        {hasMultipleImages && !isFirst && (
          <button
            type="button"
            className={`${styles.navButton} ${styles.prevButton}`}
            onClick={onPrevious}
            aria-label="Previous image"
          >
            <ArrowLeft size={20} />
          </button>
        )}

        {hasMultipleImages && !isLast && (
          <button
            type="button"
            className={`${styles.navButton} ${styles.nextButton}`}
            onClick={onNext}
            aria-label="Next image"
          >
            <ArrowRight size={20} />
          </button>
        )}

        <img
          src={imageUrl}
          alt={imageLabel || "Full screen image"}
          className={styles.fullScreenImage}
        />
        {imageLabel && <div className={styles.imageLabel}>{imageLabel}</div>}
        {hasMultipleImages && (
          <div className={styles.imageCounter}>
            {currentIndex + 1} / {images.length}
          </div>
        )}
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default FullScreenImageModal;
